<template>
  <b-dropdown-item
    v-bind="$attrs"
    v-on="mountEventListeners">
    <slot />
  </b-dropdown-item>
</template>

<script>
export default {
  name: 'CoozzyDropdownItem',
  inheritAttrs: false,
  computed: {
    mountEventListeners() {
      return this.$listeners
    }
  }
}
</script>

<style lang="scss" scoped>
  :deep(a.dropdown-item:active) {
    background-color: $color-bg-grey-dark;
    color: $color-text-grey-dark;
  }
</style>
